import { ChatCircleIcon } from '@phosphor-icons/react'
import { Button } from '@/components/ui/button'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { cn } from '@/lib/utils'

type AddToChatContextButtonProps = {
  isInContext: boolean
  onClick?: () => void
  addLabel: string
  inContextLabel: string
  className?: string
  disabled?: boolean
}

export function AddToChatContextButton({
  isInContext,
  onClick,
  addLabel,
  inContextLabel,
  className,
  disabled,
}: AddToChatContextButtonProps) {
  const isDisabled = disabled || isInContext
  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <Button
          type='button'
          variant='unstyled'
          disabled={isDisabled}
          aria-label={isInContext ? inContextLabel : addLabel}
          className={cn(
            'relative flex size-8 items-center justify-center rounded-md border focus-visible:outline-orange-500',
            isInContext ? 'border-orange-500 bg-orange-500' : 'border-neutral-300 bg-white',
            className,
          )}
          onClick={isDisabled ? undefined : onClick}
        >
          <ChatCircleIcon
            weight='bold'
            className={cn('size-3.5', isInContext ? 'text-white' : 'text-neutral-600')}
          />
        </Button>
      </TooltipTrigger>
      <TooltipContent side='bottom' align='end' sideOffset={12}>
        {isInContext ? inContextLabel : addLabel}
      </TooltipContent>
    </Tooltip>
  )
}
